import { getViewportSize, breakPoints } from 'helpers/global-variables/globalVariables';
import formatPrice from 'helpers/format-price/formatPrice';

const _config = {
    selectors: {
        dataFile: null,
        shopTheLookImageContainer: '.shopthelook-image-container',
        classNames: {
            labelLink: '.label-link',
            labelPrice: '.label-price',
            labelTitle: '.label-title',
            markerContainer: '.marker-container',
            markerButton: '.look-button',
            markerLabel: '.marker-label',
            lookButtonActive: 'active',
            labelHide: 'label-hide',
            labelShow: 'label-show',
            labelFadeIn: 'label-fadein'
        }
    },
    templates: {
        marker: function () {
            return document.querySelector(_config.selectors.shopTheLookImageContainer).querySelector('#marker-template')
                .content;
        },
        label: function () {
            return document
                .querySelector(_config.selectors.shopTheLookImageContainer)
                .querySelector('#marker-label-template').content;
        }
    },
    positionValueType: '%',
    labelOffsetPixels: 15,
    markerObject: {
        button: 0,
        label: 0
    },
    markers: [],
    activeButtons: -1,
    imageHeight: function () {
        const el = document.querySelector(_config.selectors.shopTheLookImageContainer);
        return el ? el.offsetHeight : 0;
    },
    imageWidth: function () {
        const el = document.querySelector(_config.selectors.shopTheLookImageContainer);
        return el ? el.offsetWidth : 0;
    },
    labelOffsetPercentageHeight: function () {
        return (_config.labelOffsetPixels / _config.imageHeight()) * 100;
    },
    labelOffsetPercentageWidth: function () {
        return (_config.labelOffsetPixels / _config.imageWidth()) * 100;
    }
};

const GetMarkerData = () => {
    const containers = document.querySelectorAll('.shopthelook-container');

    containers.forEach((container) => {
        // Get the stringified markers-object from the STL div
        let markers = container.getAttribute('data-markers');

        // Parse the string to a JSON object
        markers = JSON.parse(markers);

        // Transform the JSON object to an array
        markers = Object.values(markers);

        _renderMarkers(container, markers);
    });
};

const _renderMarkers = (container, markers) => {
    markers.forEach((marker) =>
        _placeMarker(container, marker.name, marker.price, marker.link, marker.posX, marker.posY)
    );
};

const _placeMarker = (container, name, price, link, posX, posY) => {
    const markerTemplate = _config.templates.marker().cloneNode(true);
    const markerContainer = markerTemplate.firstElementChild;
    const markerButton = markerContainer.querySelector(_config.selectors.classNames.markerButton);
    markerButton.style.left = posX + _config.positionValueType;
    markerButton.style.top = posY + _config.positionValueType;
    container.querySelector(_config.selectors.shopTheLookImageContainer).appendChild(markerTemplate);
    const markerObject = { ..._config.markerObject };
    markerObject.button = markerButton;
    markerObject.button.setAttribute('id', _config.markers.length.toString());
    markerObject.button.addEventListener('click', function () {
        _activateMarker(parseInt(markerObject.button.id));
    });
    container.querySelector(_config.selectors.shopTheLookImageContainer).addEventListener('click', function (event) {
        const target = event.target;
        if (
            !target.closest(_config.selectors.classNames.markerButton) &&
            !target.closest(_config.selectors.classNames.markerLabel)
        ) {
            _deactivateAll();
        }
    });
    _placeLabel(name, price, link, posX, posY, markerObject, markerContainer);
};

const _placeLabel = (name, price, link, posX, posY, markerObject, markerContainer) => {
    const labelContainer = markerContainer.querySelector(_config.selectors.classNames.markerLabel);
    _fillLabel(name, price, link, labelContainer);
    markerObject.label = labelContainer;
    _config.markers.push(markerObject);
    labelContainer.classList.add(_decideLabelPosition(labelContainer, posX, posY));
};

const _fillLabel = (name, price, link, label) => {
    const labelLink = label.querySelector(_config.selectors.classNames.labelLink);
    const labelPrice = label.querySelector(_config.selectors.classNames.labelPrice);
    const labelTitle = label.querySelector(_config.selectors.classNames.labelTitle);

    labelTitle.textContent = name;
    labelPrice.innerHTML = formatPrice(price, false);
    labelLink.href = link;
};

const _decideLabelPosition = (label, posX, posY) => {
    //Calculate the amount of space in pixels available at each side of the marker button
    const topSpace = (_config.imageHeight() / 100) * posY;
    const rightSpace = _config.imageWidth() - (_config.imageWidth() / 100) * posX;
    const bottomSpace = _config.imageHeight() - (_config.imageHeight() / 100) * posY;
    const leftSpace = (_config.imageWidth() / 100) * posX;

    label.style.left = posX + _config.positionValueType;
    label.style.top = posY + _config.positionValueType;

    //Add a certain amount of pixels as offset to the height and width of the label
    const labelHeightPixels = label.offsetHeight + _config.labelOffsetPixels;
    const labelWidthPixels = label.offsetWidth + _config.labelOffsetPixels;

    let labelPosX = '';
    let labelPosY = '';

    //Check if there is room at a certain side of the marker button
    if (topSpace > labelHeightPixels) {
        labelPosY = 'top';
    } else if (bottomSpace > labelHeightPixels) {
        labelPosY = 'bottom';
    }

    if (rightSpace > labelWidthPixels / 2 && leftSpace > labelWidthPixels / 2) {
        labelPosX = null;
    } else if (rightSpace > labelWidthPixels) {
        labelPosX = 'right';

        if (topSpace > labelHeightPixels / 2 && bottomSpace > labelHeightPixels / 2) {
            labelPosY = null;
        }
    } else if (leftSpace > labelWidthPixels) {
        labelPosX = 'left';

        if (topSpace > labelHeightPixels / 2 && bottomSpace > labelHeightPixels / 2) {
            labelPosY = null;
        }
    }

    if (!labelPosX && !labelPosY) {
        labelPosY = 'top';
    }

    let labelPosition = '';

    if (labelPosX && labelPosY) {
        labelPosition = labelPosY + '-' + labelPosX;
    } else {
        if (labelPosY) {
            labelPosition = labelPosY;
        }
        if (labelPosX) {
            labelPosition = labelPosX;
        }
    }

    return labelPosition;
};

const _activateMarker = (labelNumber) => {
    if (labelNumber !== _config.activeButtons) {
        _deactivateAllButtons(labelNumber);
        _hideAllLabels();
        _activateButton(labelNumber);
        _showLabel(labelNumber);
        _config.activeButtons = labelNumber;
    } else {
        _deactivateAll();
    }
};

const _showLabel = (labelNumber) => {
    _config.markers[labelNumber].label.classList.add(_config.selectors.classNames.labelFadeIn);
    _config.markers[labelNumber].label.classList.add(_config.selectors.classNames.labelShow);
};

const _hideLabel = (labelNumber) => {
    _config.markers[labelNumber].label.classList.remove(_config.selectors.classNames.labelShow);
    _config.markers[labelNumber].label.classList.remove(_config.selectors.classNames.labelFadeIn);
};

const _hideAllLabels = () => {
    for (let i = 0; i < _config.markers.length; i++) {
        _hideLabel(i);
    }
};

const _activateButton = (buttonNumber) => {
    _config.markers[buttonNumber].button.classList.add(_config.selectors.classNames.lookButtonActive);
};

const _deactivateButton = (buttonNumber) => {
    _config.markers[buttonNumber].button.classList.remove(_config.selectors.classNames.lookButtonActive);
};

const _deactivateAllButtons = () => {
    for (let i = 0; i < _config.markers.length; i++) {
        _deactivateButton(i);
    }
};

const _deactivateAll = () => {
    _deactivateAllButtons();
    _hideAllLabels();
    _config.activeButtons = -1;
};

const _recalculateAllLabelPositions = () => {
    _config.markers.forEach((marker) => {
        const labelPos = _decideLabelPosition(
            marker.label,
            Number(marker.button.style.left.replace('%', '')),
            Number(marker.button.style.top.replace('%', ''))
        );
        marker.label.classList.add(labelPos);
    });
};

window.onresize = function () {
    if (getViewportSize().w > breakPoints.md) {
        _recalculateAllLabelPositions();
    }
};

// Initialize
GetMarkerData();
